import React from "react"
import { injectIntl } from "gatsby-plugin-intl"
import StaticPage from "@tmu/components/StaticPage"

const FAQ = () => <StaticPage slug="faq" />

export default injectIntl(FAQ)
